module.exports = __webpack_public_path__ + "static/13gde-2c701a5b3f165d8b43903674652986f9.gif";